import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { replanningRunOutputsState } from '~/state/atoms/adaptiveReplanningAtoms';
import { findImageBySeriesUid } from '~/hooks/workflows/findImageBySeriesUid';

export interface RunScans {
    readonly planning?: Image3D;
    readonly target?: Image3D;
}

// The Plan & Target scans the run was made between, whatever has been chosen since.
export function useRunScans(): RunScans {
    const patient = useSelectedPatient();
    const { planningSeriesUid, targetSeriesUid } = useRecoilValue(
        replanningRunOutputsState
    );
    return useMemo(
        () => ({
            planning: findImageBySeriesUid(patient, planningSeriesUid),
            target: findImageBySeriesUid(patient, targetSeriesUid),
        }),
        [patient, planningSeriesUid, targetSeriesUid]
    );
}
